export const DRIVES_ENDPOINT = '/drives/v2'
export const LISTS_ENDPOINT = '/lists/v3'
export const DRIVE_LEADS_ENDPOINT = '/lists/v3/members'
export const DRIVES_STATS_ENDPOINT = '/drives/v1/stats'
export const LISTS_STATS_ENDPOINT = '/lists/v3/stats'
